import React, { useState } from "react";
import "./ContactUsSection.css";
import { openTermsPopup } from "./TermsGate";
import handWithCable from "../assests/images/contact-us-section.png";
import logo from "../assests/images/Logo.png";

const ContactUsSection = () => {
  const [formData, setFormData] = useState({
    message: "",
    number: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = () => {
    console.log("Form submitted:", formData);
    // Handle form submission here
  };

  return (
    <div
      className="min-vh-75"
      style={{ overflow: "hidden" }}
    >
      {/* Header Section */}
      <div className="container-fluid px-0">
        <div className="row g-0 min-vh-75">
          {/* Left Content Section */}
          <div className="col-lg-6 d-flex align-items-center">
            <div className="container px-4 px-lg-5">
              <div className="row">
                <div className="col-12">
                  {/* Main Heading */}
                  <div className="text-start ps-5">
                    <h1
                      className="display-3 fw-bold text-dark mb-3"
                      style={{ lineHeight: "1.1" }}
                    >
                      Your message <br />
                      <span className="text-yellow">
                        won't get lost
                      </span>{" "}
                      in <br />
                      the inbox jungle.
                    </h1>
                    <a href="/contact-us" className="btn btn-dark btn-lg rounded-pill px-5 py-3 mt-4">
                      Contact Us
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Right Image Section */}
          <div className="col-lg-6 position-relative d-flex align-items-center justify-content-center py-5 py-lg-0">
            {/* Vintage Phone Illustration */}
            <div
              className="position-relative"
            >
              {/* Phone Cord */}
              <div
                className="position-absolute"
                style={{
                  top: "-350px",
                  left: "-300px",
                  width: "700px",
                  height: "800px",
                  borderRadius: "4px",
                  zIndex: 1,
                  animation: "cordRotate 2s ease-in-out infinite",
                }}
              >
                <img src={handWithCable} width="700px" height="100%" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Section */}
      <div style={{ background: "#ffd700", minHeight: "300px" }}>
        <div className="container py-5">
          <div className="row">
            {/* Company Logo/Name */}
            <div className="col-lg-2 col-md-6 mb-4">
              <div className="d-flex align-items-center mb-3">
                <div
                  className="text-white rounded me-3 d-flex align-items-center justify-content-center"
                  style={{
                    width: "40px",
                    height: "40px",
                    fontSize: "20px",
                    fontWeight: "bold",
                  }}
                >
                  <img width="80px" src={logo} alt=""></img>
                </div>
              </div>
            </div>

            {/* Services */}
            <div className="col-lg-3 col-md-6 mb-4">
              <h5 className="fw-bolder fs-1 text-dark mb-3">Services</h5>
              <ul className="list-unstyled">
                <li className="mb-2">
                  <a href="#" className="text-white fw-bolder text-decoration-none">
                    Development
                  </a>
                </li>
                <li className="mb-2">
                  <a href="#" className="text-white fw-bolder text-decoration-none">
                    Design
                  </a>
                </li>
                <li className="mb-2">
                  <a href="#" className="text-white fw-bolder text-decoration-none">
                    Political Consult
                  </a>
                </li>
                <li className="mb-2">
                  <a href="#" className="text-white fw-bolder text-decoration-none">
                    Animation
                  </a>
                </li>
                <li className="mb-2">
                  <a href="#" className="text-white fw-bolder text-decoration-none">
                    Game Development
                  </a>
                </li>
                <li className="mb-2">
                  <a href="#" className="text-white fw-bolder text-decoration-none">
                    Public Relations
                  </a>
                </li>
                <li className="mb-2">
                  <a href="#" className="text-white fw-bolder text-decoration-none">
                    AR/VR Solutions
                  </a>
                </li>
              </ul>
            </div>

            {/* Our Company */}
            <div className="col-lg-3 col-md-6 mb-4">
              <h5 className="fw-bolder fs-1 text-dark mb-3">Our Company</h5>
              <ul className="list-unstyled">
                <li className="mb-2">
                  <a href="#" className="text-white fw-bolder text-decoration-none">
                    About Us
                  </a>
                </li>
                <li className="mb-2">
                  <a href="#" className="text-white fw-bolder text-decoration-none">
                    Portfolio
                  </a>
                </li>
                <li className="mb-2">
                  <a href="#" className="text-white fw-bolder text-decoration-none">
                    Career
                  </a>
                </li>
                <li className="mb-2">
                  <button
                    type="button"
                    onClick={openTermsPopup}
                    className="link-button text-white fw-bolder"
                  >
                    Terms & Conditions
                  </button>
                </li>
              </ul>
            </div>

            {/* Contact Form */}
            {/* <div className="col-lg-4 col-md-6">
              <div>
                <div className="mb-3">
                  <input
                    type="text"
                    className="form-control form-control-lg"
                    placeholder="Message"
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    style={{
                      background: "rgba(255, 255, 255, 0.8)",
                      border: "none",
                      borderRadius: "10px",
                    }}
                  />
                </div>
                <div className="mb-3">
                  <input
                    type="tel"
                    className="form-control form-control-lg"
                    placeholder="Number"
                    name="number"
                    value={formData.number}
                    onChange={handleInputChange}
                    style={{
                      background: "rgba(255, 255, 255, 0.8)",
                      border: "none",
                      borderRadius: "10px",
                    }}
                  />
                </div>
                <button
                  type="button"
                  className="btn btn-dark btn-lg rounded-pill px-4"
                  onClick={handleSubmit}
                >
                  Submit
                </button>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUsSection;
